"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_RULES = exports.emojiRules = exports.codeBlockRules = exports.videoRules = exports.imageRules = exports.inlineRules = exports.blockRules = exports.markRules = void 0;

var _markRules = _interopRequireDefault(require("./markRules"));

var _blockRules = _interopRequireDefault(require("./blockRules"));

var _voidBlockRules = _interopRequireDefault(require("./voidBlockRules"));

var _inlineRules = _interopRequireDefault(require("./inlineRules"));

var _imageRules = _interopRequireDefault(require("./imageRules"));

var _videoRules = _interopRequireDefault(require("./videoRules"));

var _codeBlockRules = _interopRequireDefault(require("./codeBlockRules"));

var _emojiRules = _interopRequireDefault(require("./emojiRules"));

var _voidNodeRules = _interopRequireDefault(require("./voidNodeRules"));

var _slateConstant = require("@canner/slate-constant");

var _slateIconVideo = require("@canner/slate-icon-video");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var markRules = _markRules.default;
exports.markRules = markRules;
var blockRules = _blockRules.default;
exports.blockRules = blockRules;
var inlineRules = _inlineRules.default;
exports.inlineRules = inlineRules;
var imageRules = _imageRules.default;
exports.imageRules = imageRules;
var videoRules = _videoRules.default;
exports.videoRules = videoRules;
var codeBlockRules = _codeBlockRules.default;
exports.codeBlockRules = codeBlockRules;
var emojiRules = _emojiRules.default;
exports.emojiRules = emojiRules;
var DEFAULT_RULES = [blockRules("p", _slateConstant.BLOCKS.PARAGRAPH), blockRules("blockquote", _slateConstant.BLOCKS.BLOCKQUOTE), blockRules("h1", _slateConstant.BLOCKS.HEADING_1), blockRules("h2", _slateConstant.BLOCKS.HEADING_2), blockRules("h3", _slateConstant.BLOCKS.HEADING_3), blockRules("h4", _slateConstant.BLOCKS.HEADING_4), blockRules("h5", _slateConstant.BLOCKS.HEADING_5), blockRules("h6", _slateConstant.BLOCKS.HEADING_6), blockRules("ul", _slateConstant.BLOCKS.UL_LIST), blockRules("ol", _slateConstant.BLOCKS.OL_LIST), blockRules("li", _slateConstant.BLOCKS.LIST_ITEM), blockRules("table", _slateConstant.BLOCKS.TABLE), blockRules("tr", _slateConstant.BLOCKS.TABLE_ROW), blockRules("td", _slateConstant.BLOCKS.TABLE_CELL), (0, _voidBlockRules.default)("hr", _slateConstant.BLOCKS.HR), inlineRules("a", _slateConstant.INLINES.LINK), markRules("strong", _slateConstant.MARKS.BOLD), markRules("code", _slateConstant.MARKS.CODE), markRules("i", _slateConstant.MARKS.ITALIC), markRules("s", _slateConstant.MARKS.STRIKETHROUGH), markRules("u", _slateConstant.MARKS.UNDERLINE), markRules("span", _slateConstant.MARKS.FONTBGCOLOR), markRules("span", _slateConstant.MARKS.FONTCOLOR), markRules("span", _slateConstant.MARKS.FONTSIZE), markRules("span", _slateConstant.MARKS.LETTERSPACING), videoRules(_slateIconVideo.DEFAULT.youtube), videoRules(_slateIconVideo.DEFAULT.vimeo), videoRules(_slateIconVideo.DEFAULT.dailymotion), videoRules(_slateIconVideo.DEFAULT.youku), imageRules(_slateConstant.INLINES.IMAGE), codeBlockRules(), emojiRules(), // some void node types that generate from 'markup-it'
(0, _voidNodeRules.default)("unstyled"), (0, _voidNodeRules.default)("html")];
exports.DEFAULT_RULES = DEFAULT_RULES;